import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, model, signal } from '@angular/core';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe, NgIf, TitleCasePipe } from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import { ProfilService } from '../../services/profil-service';
import { Profil } from '../../../shared/model';
import { ToastrService } from '../../../shared/services/toastr-service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatListModule} from '@angular/material/list';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDivider } from "@angular/material/divider";
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { HttpClient } from '@angular/common/http';

interface DroitI{
  title : string,
  droit : string
}
export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Profil
}

@Component({
  selector: 'app-profil-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    TitleCasePipe,
    MatSpinner,
    MatExpansionModule,
    MatSlideToggleModule,
    MatListModule,
    MatFormFieldModule,
],
  templateUrl: './profil-component.html',
  styleUrl: './profil-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilComponent {

  loading = signal(false)
  searchValue = signal<string>('')
  readonly panelOpenState = signal(false);
  readonly dialog = inject(MatDialog)
  profils = signal<any[]>([])
  profilsOrigin = signal<any[]>([])
  profilForm : FormGroup = new FormGroup({})
  currentProfil = signal<Profil>(new Profil())

  droits : DroitI[] = []

  constructor(
    private profilService : ProfilService,
    private toastr : ToastrService,
    private fb : FormBuilder,
    private sweetAlert : SweetAlertService,
    private http : HttpClient
  ){
    http.get<DroitI[]>('/rights.json').subscribe((res) => this.droits = res)
  }

  ngOnInit(): void {
    this.profilService.getAll().subscribe({
      next : (res) => {
        this.profils.update(p => p = res)
        this.profilsOrigin.update(p => p = res)
      },
      error : (err) => this.toastr.error((err.error.message)??"une erreur est survenue")
    })

  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    let data = this.profils() as Profil[]
    const value = event.toLocaleLowerCase().trim()
    if(value!==''){
      data = data.filter(item =>{
        
        if(item.name.includes(value))
          return item

        return;
      })
      this.profils.update(profil => profil = data)
    }else{
      this.profils.update(profil => profil = this.profilsOrigin())
    }
  }

  allRightIsAcive(profil : any){
    let state = true

    this.droits.forEach(item =>{
      if(!profil[item.droit]){
        state = false
        return ;
      }
    })

    return state
  }

  onChangeRigth(id : string, right : string){
    this.profilService.changeRightState(id, right).subscribe({
      next : (res) =>{
        console.log(res);
        const data = this.profils()
        const i = data.findIndex(item => item.id == id)
        data[i] = res
        this.profils.update(p => data)
        this.toastr.success('Reglage mis a jour')
      },
      error : (err) => this.toastr.error((err.error.message)??"une erreur est survenue")
    })
  }

  onChangeRigthsProfil(id : string, val : boolean){
    this.loading.update(val => true)
    const rights : any[] = []
    this.droits.forEach(item => rights.push(Object.values(item)[1]))

    const data = {
      value : val,
      rights : rights
    }

    this.profilService.changeRightStatesProfil(id, data).subscribe({
      next : (res) =>{
        const data = this.profils()
        const i = data.findIndex(item => item.id == id)
        data[i] = res
        this.profils.update(p => data)
        this.toastr.success('Reglage mis a jour')
        this.loading.update(val => false)
      },
      error : (err) => {
        this.toastr.error('Une erreur est survenue ')
        this.loading.update(val => false)
      }
    })
  }

  openAddProfilModal(){
    const data : ModalDataI = {
      title : 'Ajouter un profil',
      data : new Profil()
    }

    const dialogRef = this.dialog.open(ProfilComponentModal, {
      width : '500px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Profil) => {

      if (result?.id != undefined) {
        const data : Profil[] = []
        data.push(...this.profils())
        data.push(result)

        this.profils.update(profil => profil = data)
        this.toastr.success("Le profil "+ result.name + " à été ajouté")
      }
    });
  }

  openUpdate(profil : Profil){
    this.currentProfil.set(profil)

    const data : ModalDataI = {
      title : 'Modifier le collaborateur ' + profil.name,
      update : true,
      data : this.currentProfil()
    }

    const dialogRef = this.dialog.open(ProfilComponentModal, {
      width : '500px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Profil) => {

      if (result?.id != undefined) {
        const data = this.profils()
        const i = data.findIndex(item => item.id == result.id)
        data[i] = result
        this.profils.update(profil => profil = data)
        this.toastr.success("Le profil "+ result.name + " à été modifie")
      }
    });
  }


  confirmDelete(profil : Profil){
    this.sweetAlert.confirm('Etez-vous sur de vouloir supprimer le profil '+profil.name).then((res) =>{
      if(res.isConfirmed){
        this.profilService.delete(profil.id).subscribe({
          next : (res) =>{
            const data = this.profils()
            this.profils.update(p => p = data.filter(item => item.id != profil.id))
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

}

@Component({
  selector: 'app-profil-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule
  ],
  templateUrl: './modal-profil.html',
  styleUrl: './modal-profil.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilComponentModal {
  readonly dialogRef = inject(MatDialogRef<ProfilComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly profil = model(this.inputData.data!);

  profilForm : FormGroup = new FormGroup({})

  constructor(
    private fb : FormBuilder,
    private profilService : ProfilService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.profilForm = this.fb.group({
      name : ['', [Validators.required]]
    })
  }

  ngAfterViewInit(): void {
    this.profilForm.patchValue(this.inputData?.data!)
  }

  resetForm(){
    this.profilForm.patchValue({
      name : ''
    })
  }


  onAdd(){
    const data = this.profilForm.value

    this.profilService.create(data).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    const data = this.profilForm.value;

    this.profilService.update(data, this.inputData.data?.id!).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }


}
